// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__zwsUt","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__-H26j","gfeWrapper":"CalendarEvent_gfeWrapper__1LaN7"};